<template>
    <span>
        <font-awesome-icon
            icon="paper-plane"
            fixed-width />
        <span>
            {{ $t('menu.regSummary') }}
        </span>
    </span>
</template>
<script>
export default {
    name: 'MenuItemRegSummary'
}
</script>
<style lang="scss" scoped>


</style>